export default __webpack_public_path__ + "static/twitter-4d92cbb6837397a8ee60f4833992e7a3.png";